import { render, staticRenderFns } from "./ClientType.vue?vue&type=template&id=747d9f56&"
import script from "./ClientType.vue?vue&type=script&lang=js&"
export * from "./ClientType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports